// extracted by mini-css-extract-plugin
module.exports = {"titleClass":"ValentineShareModal_titleClass__2Buyq","alertMesage":"ValentineShareModal_alertMesage__yN4Wd"};